/** Se a tela é estreita demais para o Kanban (SPEC-FE-001 § 5).
 *
 * O corte é 768 px, e ele não é estético: a coluna do board tem 300 px fixos.
 * Num telefone de 360 px, uma coluna já não cabe inteira — a pessoa arrasta na
 * horizontal para ler uma etapa e na horizontal de novo para chegar à seguinte,
 * e perde a referência de onde estava a cada gesto. Abaixo desse ponto o funil
 * vira lista com abas.
 *
 * **Em JavaScript e não só em CSS**, porque a diferença não é de aparência: o
 * modo lista tem abas, não tem arrastar e soltar, e monta outra árvore. Esconder
 * a versão errada com `hidden` deixaria as duas montadas — dois `DndContext`,
 * duas assinaturas de teclado, o dobro de cards no DOM do aparelho mais fraco.
 */

import { useEffect, useState } from "react";

/** Onde a coluna de 300 px deixa de caber com folga. */
export const LARGURA_DE_CORTE = 768;

const CONSULTA = `(max-width: ${String(LARGURA_DE_CORTE - 1)}px)`;

export function useTelaEstreita(): boolean {
  const [estreita, setEstreita] = useState(consultar);

  useEffect(() => {
    // `typeof` e não `?.`: o tipo declara `matchMedia` como sempre presente, e
    // o `?.` vira erro de lint. Em jsdom ele não existe — o tipo é que mente.
    if (typeof window.matchMedia !== "function") return;
    const media = window.matchMedia(CONSULTA);

    function atualizar(evento: MediaQueryListEvent) {
      setEstreita(evento.matches);
    }
    media.addEventListener("change", atualizar);
    // Girar o aparelho entre a primeira renderização e este efeito é possível,
    // e barato de cobrir.
    setEstreita(media.matches);
    return () => {
      media.removeEventListener("change", atualizar);
    };
  }, []);

  return estreita;
}

/** Ambiente sem `matchMedia` conta como tela larga.
 *
 * jsdom não o implementa por padrão. O engano seguro é o Kanban: ele é o que a
 * suíte inteira já exercita, e um teste que caísse no modo lista por acidente
 * passaria a verificar outra tela sem ninguém notar.
 */
function consultar(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia(CONSULTA).matches;
}
